(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lilmonal-canvas-options"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('lm-canvas-options')) {
  customElements.define('lm-canvas-options', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.items = [...this.querySelectorAll('.lmco__item')];
      this.stage = this.querySelector('.lmco__stage');
      this.media = window.matchMedia('(min-width: 990px)');
      this.active = this.items.find(item => item.open) || this.items[0];
      this.classList.add('lmco--enhanced');
      this.items.forEach(item => {
        item.querySelector('summary').addEventListener('click', event => {
          event.preventDefault();
          this.activate(item);
        }, options);
      });
      this.media.addEventListener('change', () => this.placeImage(), options);
      document.addEventListener('shopify:block:select', event => {
        const item = this.items.find(candidate => candidate.dataset.option === event.detail?.blockId);
        if (item) this.activate(item);
      }, options);
      const launch = document.querySelector('[data-lm-canvas] [data-canvas-launch]');
      const button = this.querySelector('[data-lmco-customize]');
      const fallback = this.querySelector('[data-lmco-fallback]');
      if (launch && button) {
        button.hidden = false;
        fallback.hidden = true;
        button.addEventListener('click', () => {
          if (!launch.disabled) launch.click();
          else { launch.scrollIntoView({block: 'center'}); launch.focus(); }
        }, options);
      }
      if (this.active) this.activate(this.active);
    }
    activate(item) {
      this.active = item;
      this.items.forEach(candidate => { candidate.open = candidate === item; });
      this.placeImage();
    }
    placeImage() {
      const previous = this.stage.querySelector('.lmco__figure');
      if (previous) this.items.find(item => item.dataset.option === previous.dataset.visual)?.querySelector('.lmco__image-home').append(previous);
      this.stage.hidden = !this.media.matches || !this.active;
      if (this.media.matches && this.active) {
        const figure = this.active.querySelector('.lmco__figure');
        if (figure) this.stage.append(figure);
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lilmonal-canvas-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lm-canvas-page'))customElements.define('lm-canvas-page',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const opt={signal:this.abort.signal};
  this.labels=JSON.parse(this.querySelector('[data-lmcp-labels]').textContent);
  this.buttons=[...this.querySelectorAll('[data-size]')];this.root=this.querySelector('[data-lm-canvas]');
  this.variants=this.buttons.map(b=>({id:Number(b.dataset.size),w:Number(b.dataset.w),h:Number(b.dataset.h),available:b.dataset.available==='true',price:b.dataset.priceText,compare:b.dataset.compareText,button:b}));
  this.current=this.variants.find(v=>v.id===Number(this.dataset.selected))||this.variants[0];this.orientation='landscape';
  this.buttons.forEach(b=>b.addEventListener('click',()=>this.choose(Number(b.dataset.size)),opt));
  this.querySelectorAll('[data-group]').forEach(b=>b.addEventListener('click',()=>this.filter(b.dataset.group),opt));
  this.querySelectorAll('[data-orientation]').forEach(b=>b.addEventListener('click',()=>{this.orientation=b.dataset.orientation;this.sync();},opt));
  this.querySelectorAll('[data-choose]').forEach(b=>b.addEventListener('click',()=>{this.choose(Number(b.dataset.choose));this.querySelector('.lmcp__buy').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});this.current.button.focus({preventScroll:true});},opt));
  this.root.addEventListener('lm-canvas:ready',()=>this.sync(),opt);
  this.root.addEventListener('lm-canvas:orientation',e=>{if(e.detail.variantId!==this.current?.id)return;this.orientation=e.detail.width>e.detail.height?'landscape':'portrait';this.sync(false);},opt);
  const dock=this.querySelector('.lmcp__dock');dock.hidden=false;
  this.querySelector('[data-dock-launch]').addEventListener('click',()=>this.querySelector('[data-canvas-launch]').click(),opt);
  this.slide=0;this.slides=[...this.querySelectorAll('[data-slide]')];
  const show=i=>{if(!this.slides.length)return;this.slide=(i+this.slides.length)%this.slides.length;this.slides.forEach((el,j)=>el.hidden=j!==this.slide);this.querySelectorAll('[data-thumb]').forEach((b,j)=>b.setAttribute('aria-pressed',String(j===this.slide)));const count=this.querySelector('[data-counter]');if(count)count.textContent=(this.slide+1)+' / '+this.slides.length;};
  if (this.slides.length > 1) {
  const pause = document.createElement('button');
  pause.type = 'button';

  let playing = !matchMedia('(prefers-reduced-motion: reduce)').matches;

  const updatePause = () => {
    pause.textContent = playing ? 'Ⅱ' : '▶';
    pause.setAttribute(
      'aria-label',
      playing ? 'Pause slideshow' : 'Play slideshow'
    );
  };

  updatePause();
  this.querySelector('.lmcp__gallery-nav').append(pause);

  pause.addEventListener('click', () => {
    playing = !playing;
    updatePause();
  }, opt);

  const timer = setInterval(() => {
    if (
      playing &&
      !document.hidden &&
      !document.querySelector('.lm-canvas-dialog[open]')
    ) {
      show(this.slide + 1);
    }
  }, 5000);

  this.abort.signal.addEventListener('abort', () => {
    clearInterval(timer);
    pause.remove();
  }, { once: true });
}
  this.querySelectorAll('[data-thumb]').forEach(b=>b.addEventListener('click',()=>show(Number(b.dataset.thumb)),opt));
  this.querySelector('[data-prev]')?.addEventListener('click',()=>show(this.slide-1),opt);this.querySelector('[data-next]')?.addEventListener('click',()=>show(this.slide+1),opt);
  this.querySelector('.lmcp__images').addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();show(this.slide+(e.key==='ArrowLeft'?-1:1));}},opt);
  window.addEventListener('popstate',()=>{const id=Number(new URL(location.href).searchParams.get('variant'));if(this.variants.some(v=>v.id===id))this.choose(id,false);},opt);
  this.sync();
 }
 group(v){return v.w===v.h?'square':Math.max(v.w,v.h)/Math.min(v.w,v.h)>=2?'panoramic':'rectangle';}
 filter(group){this.querySelectorAll('[data-group]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.group===group)));this.variants.forEach(v=>v.button.hidden=this.group(v)!==group);}
 choose(id,updateURL=true){const v=this.variants.find(v=>v.id===id);if(!v?.available||!v.w||!v.h)return;this.current=v;if(updateURL){const u=new URL(location.href);u.searchParams.set('variant',id);history.replaceState(null,'',u);}this.sync();}
 sync(send=true){
  const v=this.current;if(!v)return;const valid=v.available&&v.w>0&&v.h>0;
  const dims=x=>this.orientation==='portrait'?[Math.min(x.w,x.h),Math.max(x.w,x.h)]:[Math.max(x.w,x.h),Math.min(x.w,x.h)];
  const [w,h]=dims(v),label=x=>{const [a,b]=dims(x);return a+'″ × '+b+'″';};
  this.filter(this.group(v));
  this.variants.forEach(x=>{x.button.textContent=x.w&&x.h?label(x):x.button.textContent;x.button.disabled=!x.available||!x.w||!x.h;x.button.setAttribute('aria-pressed',String(x.id===v.id));const card=this.querySelector('[data-card-label="'+x.id+'"]');if(card&&x.w&&x.h)card.textContent=label(x);const drawing=this.querySelector('[data-drawing="'+x.id+'"]');if(drawing&&x.w&&x.h){const [a,b]=dims(x);drawing.style.width=(a>=b?90:90*a/b)+'%';drawing.style.height=(b>=a?90:90*b/a)+'%';}});
  this.querySelector('[data-price]').textContent=v.price;this.querySelector('[data-dock-price]').textContent=v.price;
  const compare=this.querySelector('[data-compare]');compare.textContent=v.compare;compare.hidden=!v.compare;
  this.querySelectorAll('[data-orientation]').forEach(b=>{b.disabled=w===h;b.setAttribute('aria-pressed',String(w!==h&&b.dataset.orientation===this.orientation));});
  this.querySelector('[data-selection]').textContent=valid?label(v)+' · '+this.labels[w===h?'square':this.orientation]:this.labels.unavailable;
  this.querySelector('form [name="id"]').value=String(v.id);this.root.dataset.selectedVariant=String(v.id);
  if(send&&valid)this.root.dispatchEvent(new CustomEvent('lm-canvas:select',{detail:{variantId:v.id,width:w,height:h}}));
  const launch=this.querySelector('[data-canvas-launch]');launch.disabled=!valid||this.root.dataset.canvasReady!=='true';this.querySelector('[data-dock-launch]').disabled=launch.disabled;
  if(!valid)this.querySelector('[data-canvas-status]').textContent=this.labels.unavailable;
 }
 disconnectedCallback(){this.abort?.abort();}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lilmonal-metal-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lm-metal-page'))customElements.define('lm-metal-page',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const opt={signal:this.abort.signal};
  this.labels=JSON.parse(this.querySelector('[data-lmcp-labels]').textContent);
  this.buttons=[...this.querySelectorAll('[data-size]')];this.root=this.querySelector('[data-lm-metal]');
  this.variants=this.buttons.map(b=>({id:Number(b.dataset.size),w:Number(b.dataset.w),h:Number(b.dataset.h),available:b.dataset.available==='true',price:b.dataset.priceText,compare:b.dataset.compareText,button:b}));
  this.current=this.variants.find(v=>v.id===Number(this.dataset.selected))||this.variants[0];this.orientation=this.current.w>this.current.h?'landscape':'portrait';
  this.buttons.forEach(b=>b.addEventListener('click',()=>this.choose(Number(b.dataset.size)),opt));
  this.querySelectorAll('[data-group]').forEach(b=>b.addEventListener('click',()=>this.filter(b.dataset.group),opt));
  this.querySelectorAll('[data-orientation]').forEach(b=>b.addEventListener('click',()=>{const target=b.dataset.orientation;const mate=this.variants.find(v=>Math.min(v.w,v.h)===Math.min(this.current.w,this.current.h)&&Math.max(v.w,v.h)===Math.max(this.current.w,this.current.h)&&(target==='portrait'?v.w<v.h:v.w>v.h));if(mate)this.choose(mate.id);},opt));
  this.querySelectorAll('[data-choose]').forEach(b=>b.addEventListener('click',()=>{this.choose(Number(b.dataset.choose));this.querySelector('.lmcp__buy').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});this.current.button.focus({preventScroll:true});},opt));
  this.root.addEventListener('lm-metal:ready',()=>this.sync(),opt);
  this.root.addEventListener('lm-metal:orientation',e=>{if(e.detail.variantId!==this.current?.id)return;this.orientation=e.detail.width>e.detail.height?'landscape':'portrait';this.sync(false);},opt);
  const dock=this.querySelector('.lmcp__dock');dock.hidden=false;
  this.querySelector('[data-dock-launch]').addEventListener('click',()=>this.querySelector('[data-metal-launch]').click(),opt);
  this.slide=0;this.slides=[...this.querySelectorAll('[data-slide]')];
  const show=i=>{if(!this.slides.length)return;this.slide=(i+this.slides.length)%this.slides.length;this.slides.forEach((el,j)=>el.hidden=j!==this.slide);this.querySelectorAll('[data-thumb]').forEach((b,j)=>b.setAttribute('aria-pressed',String(j===this.slide)));const count=this.querySelector('[data-counter]');if(count)count.textContent=(this.slide+1)+' / '+this.slides.length;};
  if (this.slides.length > 1) {
  const pause = document.createElement('button');
  pause.type = 'button';

  let playing = !matchMedia('(prefers-reduced-motion: reduce)').matches;

  const updatePause = () => {
    pause.textContent = playing ? 'Ⅱ' : '▶';
    pause.setAttribute(
      'aria-label',
      playing ? 'Pause slideshow' : 'Play slideshow'
    );
  };

  updatePause();
  this.querySelector('.lmcp__gallery-nav').append(pause);

  pause.addEventListener('click', () => {
    playing = !playing;
    updatePause();
  }, opt);

  const timer = setInterval(() => {
    if (
      playing &&
      !document.hidden &&
      !document.querySelector('.lm-canvas-dialog[open]')
    ) {
      show(this.slide + 1);
    }
  }, 5000);

  this.abort.signal.addEventListener('abort', () => {
    clearInterval(timer);
    pause.remove();
  }, { once: true });
}
  this.querySelectorAll('[data-thumb]').forEach(b=>b.addEventListener('click',()=>show(Number(b.dataset.thumb)),opt));
  this.querySelector('[data-prev]')?.addEventListener('click',()=>show(this.slide-1),opt);this.querySelector('[data-next]')?.addEventListener('click',()=>show(this.slide+1),opt);
  this.querySelector('.lmcp__images').addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();show(this.slide+(e.key==='ArrowLeft'?-1:1));}},opt);
  window.addEventListener('popstate',()=>{const id=Number(new URL(location.href).searchParams.get('variant'));if(this.variants.some(v=>v.id===id))this.choose(id,false);},opt);
  this.sync();
 }
 group(v){return v.w===v.h?'square':Math.max(v.w,v.h)/Math.min(v.w,v.h)>=2?'panoramic':'rectangle';}
 filter(group){this.querySelectorAll('[data-group]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.group===group)));this.variants.forEach(v=>{const hidden=this.group(v)!==group||(v.w!==v.h&&(this.orientation==='portrait'?v.w>v.h:v.w<v.h));v.button.hidden=hidden;const card=this.querySelector('[data-choose="'+v.id+'"]');if(card)card.hidden=v.w!==v.h&&(this.orientation==='portrait'?v.w>v.h:v.w<v.h)});}
 choose(id,updateURL=true){const v=this.variants.find(v=>v.id===id);if(!v?.available||!v.w||!v.h)return;this.current=v;this.orientation=v.w>v.h?'landscape':'portrait';if(updateURL){const u=new URL(location.href);u.searchParams.set('variant',id);history.replaceState(null,'',u);}this.sync();}
 sync(send=true){
  const v=this.current;if(!v)return;const valid=v.available&&v.w>0&&v.h>0;
  const dims=x=>[x.w,x.h];
  const [w,h]=dims(v),label=x=>{const [a,b]=dims(x);return a+'″ × '+b+'″';};
  this.filter(this.group(v));
  this.variants.forEach(x=>{x.button.textContent=x.w&&x.h?label(x):x.button.textContent;x.button.disabled=!x.available||!x.w||!x.h;x.button.setAttribute('aria-pressed',String(x.id===v.id));const card=this.querySelector('[data-card-label="'+x.id+'"]');if(card&&x.w&&x.h)card.textContent=label(x);const drawing=this.querySelector('[data-drawing="'+x.id+'"]');if(drawing&&x.w&&x.h){const [a,b]=dims(x);drawing.style.width=(a>=b?90:90*a/b)+'%';drawing.style.height=(b>=a?90:90*b/a)+'%';}});
  this.querySelector('[data-price]').textContent=v.price;this.querySelector('[data-dock-price]').textContent=v.price;
  const compare=this.querySelector('[data-compare]');compare.textContent=v.compare;compare.hidden=!v.compare;
  this.querySelectorAll('[data-orientation]').forEach(b=>{b.disabled=w===h;b.setAttribute('aria-pressed',String(w!==h&&b.dataset.orientation===this.orientation));});
  this.querySelector('[data-selection]').textContent=valid?label(v)+' · '+this.labels[w===h?'square':this.orientation]:this.labels.unavailable;
  this.querySelector('form [name="id"]').value=String(v.id);this.root.dataset.selectedVariant=String(v.id);
  if(send&&valid)this.root.dispatchEvent(new CustomEvent('lm-metal:select',{detail:{variantId:v.id,width:w,height:h}}));
  const launch=this.querySelector('[data-metal-launch]');launch.disabled=!valid||this.root.dataset.metalReady!=='true';this.querySelector('[data-dock-launch]').disabled=launch.disabled;
  if(!valid)this.querySelector('[data-metal-status]').textContent=this.labels.unavailable;
  const small=(Math.min(w,h)===5&&Math.max(w,h)===7)||(Math.min(w,h)===8&&Math.max(w,h)===10);this.querySelector('[data-mounting-note]').textContent=small?'Tabletop display · Bamboo stand included · '+w+'″ × '+h+'″':'Wall display · Mounting block included · Customer assembly required';

 }
 disconnectedCallback(){this.abort?.abort();}
});


  } catch(e) { console.error(e); }
})();
})();
